export var SocialSignOnProvider;
(function (SocialSignOnProvider) {
    SocialSignOnProvider["SOCIAL_SIGN_ON_PROVIDER_UNKNOWN"] = "SOCIAL_SIGN_ON_PROVIDER_UNKNOWN";
    SocialSignOnProvider["GOOGLE"] = "GOOGLE";
    SocialSignOnProvider["APPLE"] = "APPLE";
    SocialSignOnProvider["OKTA"] = "OKTA";
    SocialSignOnProvider["FACEBOOK"] = "FACEBOOK";
})(SocialSignOnProvider || (SocialSignOnProvider = {}));
